import { Injectable } from '@nestjs/common';
import { AssetCheckListDto } from './asset-checklist.dto';
import { AssetCheckListEntity } from './asset-checklist.entity';


@Injectable()
export class AssetCheckListAdapter {
  
  public convertDtoToEntity(checklistmodelDTO: AssetCheckListDto,  isUpdate: boolean = false ):AssetCheckListEntity {
    console.log(checklistmodelDTO);
    const checklistmodelentity = new AssetCheckListEntity();
    checklistmodelentity.checkListid=checklistmodelDTO.checkListid;
    checklistmodelentity.assetCategoryId=checklistmodelDTO.assetCategoryId;
    checklistmodelentity.checkListName=checklistmodelDTO.checkListName;
    checklistmodelentity.subName=checklistmodelDTO.subName;
    checklistmodelentity.model=checklistmodelDTO.model;

    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    checklistmodelentity.isActive=checklistmodelDTO.isActive==undefined?true:checklistmodelDTO.isActive;
    if (isUpdate) {
        checklistmodelentity.updatedUser = checklistmodelDTO.updatedUser;
    } else {
        checklistmodelentity.isActive = true;
        checklistmodelentity.createdUser = checklistmodelDTO.createdUser;
    }
   return checklistmodelentity;
  }
  public convertEntityToDto(checklistmodelentity:  AssetCheckListEntity): AssetCheckListDto {
    const checklistmodelDto= new AssetCheckListDto;
    checklistmodelDto.checkListid=checklistmodelentity.checkListid;
    checklistmodelDto.assetCategoryId=checklistmodelentity.assetCategoryId;
    checklistmodelDto.checkListName=checklistmodelentity.checkListName;
    checklistmodelDto.model=checklistmodelentity.model;
    checklistmodelDto.subName=checklistmodelentity.subName;
    checklistmodelDto.isActive = checklistmodelentity.isActive;
    checklistmodelDto.createdAt = checklistmodelentity.createdAt;
    checklistmodelDto.updatedAt = checklistmodelentity.updatedAt;
    checklistmodelDto.createdUser = checklistmodelentity.createdUser;
    checklistmodelDto.updatedUser = checklistmodelentity.updatedUser;
    checklistmodelDto.versionFlag = checklistmodelentity.versionFlag;
    return checklistmodelDto;
  }
}
